import React, { Component } from 'react';
import * as GServ from '../services/GatewayService';
import { CircularProgress, Button } from '@material-ui/core';

export default class CheckAppStatus extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showSpinner: false,
            status: 'Please confirm in order to continue...',
            warning: '',
            // hasAppliedToInstBefore: null,
            // hasAppliedBeforeOnForm: null,
            // hasOpenApplicationOnForm: null,
            // isOpenAppAutoReg: null,
            // isOpenAppPaid: null,
            // isOpenAppPayGate: null,
            // isOpenAppRegistered: null,
            canSubmit: true,
            checkComplete: false,
            selectedOption: '',
            comms_error: false,
            regretHeader: '',
            regretText: '',
            showRegret: false,
            showBackToPaygate: false,
            openAppId : null,
            paygate_url: null,
        }
    }
           
    render() {
        return (
            <div>
                {!this.state.showRegret&&!this.state.showBackToPaygate&&
                <div>
                    <h3>Email address already on file...</h3>
                    <p>Thank you, we've found that your email address is associated with the details below. Please confirm we have the correct person... <br /><br/>
                    First Name: <b>{this.props.fname}</b><br/>
                    Last Name: <b>{this.props.lname}</b>
                    <br/><br/>
                    <i>If this is not you, please click the left button below</i>
                    <br/>
                    </p>
                    
                    <Button 
                        variant='contained'
                        // color='secondary'
                        size='large'
                        id="bad_name"
                        name="bad_name"
                        onClick={this.badName}
                        disabled={!this.state.canSubmit}
                    >
                        <span>  No, I'm <b><u>not</u></b> {this.props.fname} {this.props.lname}!</span>
                    </Button>
                    <br/><br/>
                    {/* 
                    <button id="bad_name" name="bad_name" className="button" style={{verticalAlign:'middle',width:'350px'}} onClick={this.badName} disabled={!this.state.canSubmit}><span>  No, I'm <b><u>not</u></b> {this.props.fname} {this.props.lname}! There seems to be some mistake... </span></button> */}
                    &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                    <Button 
                        variant='contained'
                        color='primary'
                        size='large'
                        id="proceed"
                        name="proceed"
                        onClick={this.proceedOk}
                        disabled={!this.state.canSubmit}
                    >
                        <span>  Yes, I am <b>{this.props.fname} {this.props.lname}</b>  </span>
                    </Button>
                    <br/><br/>
                    {/* <button id="proceed" name="proceed" className="button" style={{verticalAlign:'middle',width:'350px'}} onClick={this.proceedOk} disabled={!this.state.canSubmit}><span>  Yes, I am <b>{this.props.fname} {this.props.lname}</b>  </span></button> */}
                </div>}

                {this.state.showRegret&&
                <div>
                    <h3>{this.state.regretHeader}</h3>
                    <p>{this.state.regretText}
                        <br/>
                        <br/>
                        Please contact us directly as you're able to, so we can help you with the rest of the process - 
                            <br/><a href={'mailto:' + this.props.info_email}>{this.props.info_email}</a>
                            <br/>{this.props.contact_phone}
                            <br/>
                            <a href={'https://' + this.props.domain}>Home</a>
                    </p>
                </div>}

                {this.state.showBackToPaygate&&
                <div>
                    <h3>Your registration is nearly complete...</h3>
                    
                    <p>
                        The registration process for our <b>{this.props.application_for}</b> programme is almost finished...  we just need to process your payment in order to finalise your registration.
                    </p>



                    <Button 
                        variant='contained'
                        size='large'
                        color='primary'
                        id="paygate_link"
                        name="paygate_link"
                        onClick={this.backToPayGate}
                        type='submit'
                        disabled={!this.state.canSubmit}
                    >
                        <span>Proceed to Payment Portal</span>
                    </Button>
                   
                    {/* <button id="paygate_link" name="paygate_link" className="button" style={{verticalAlign:'middle',width:'350px'}} onClick={this.backToPayGate} disabled={!this.state.canSubmit}><span>Proceed to Payment Portal</span></button>
                    */}
                    <p>
                        If you are having difficulty with the payment process, or if you need any other help with your registration, please feel free to contact us - 
                        <br/><a href={'mailto:' + this.props.info_email}>{this.props.info_email}</a>
                        <br/>{this.props.contact_phone}
                        <br/>
                        <a href={'https://' + this.props.domain}>Home</a>
                    </p>

                </div>}


                <hr/>
                <span id="StatusBar" className="StatusBar">
                    {this.state.showSpinner&&<CircularProgress size={30} />}&nbsp;&nbsp;
                    {this.state.status}
                </span>
                <span className='warningMessage'>{this.state.warning}</span>
            </div>
        );
    }

    badName = () => {
        this.setState({showSpinner:true});
        //user has indicated there's a problem with their name... -> go to main regret page!
        // console.log('Name conflict - redirect to regret page...')
        this.props.setParentState({showCheckAppStatus:false,showRegret:true});
    }

    proceedOk = () => {
        this.setState({showSpinner:true,status:'Checking on previous applications...'});
        GServ.get_app_status(this.props.gwt)
        .then(appStatus=>{
        //   console.log('appStatus :>> ', appStatus);  
          if (appStatus.Result==="Success"){

            //Perhaps don't need to populate state here...
            // this.setState({
            //     hasAppliedToInstBefore: appStatus.has_applied_before_to_inst,
            //     hasAppliedBeforeOnForm: appStatus.hasAppliedBeforeOnForm,
            //     hasOpenApplicationOnForm: appStatus.hasOpenApplicationOnForm,
            //     isOpenAppAutoReg: appStatus.isOpenAppAutoReg,
            //     isOpenAppPaid: appStatus.isOpenAppPaid,
            //     isOpenAppPayGate: appStatus.isOpenAppPayGate,
            //     isOpenAppRegistered: appStatus.isOpenAppRegistered,
            // });

            if (appStatus.hasOpenApplicationOnForm){
                //Has an active application already for this form... -> See what kind of app it is, and then either display regret message or do something else...

                if (appStatus.isOpenAppPayGate && !appStatus.isOpenAppPaid){
                    //We have an unpaid paygate app open... give message and an option to redirect back to paygate...
                    this.setState({showSpinner:false,status:'',warning:'',showRegret:false, showBackToPaygate:true,regretHeader:'',regretText:'',openAppId: appStatus.openAppId});

                } else {
                    //it's not an unpaid paygate app, therefore there's a live app in progress... 
                    //Regret Message
                    this.setState({showSpinner:false,status:'',warning:'',showRegret:true,regretHeader:'Application already in progress...',regretText:'We appear to have an application for ' + this.props.application_for + ' from you, which is in progress. If would like to find out about the status of your application, or have any other query, please contact us at - '});
                }
            
            } else if (appStatus.hasAppliedBeforeOnForm&&!this.props.may_reapply_on_form){
                //Can't re-apply
            //   console.log('Previous application found for form, and form doesnt allow re-application...');
                this.setState({showSpinner:false,status:'',warning:'',showRegret:true,regretHeader:'Previous application on file...',regretText:'We have previously received an application from you for ' + this.props.application_for + ', and we are not able to process a second application for the same applicant. If would like to find out about the status of your previous application, or have any other query, please contact us at - '});
            } else {
                //Cleared for launch...
            //   console.log('Cleared for launch...');
                this.props.setParentState({showCheckAppStatus:false,showMainForm:true});
            }

          } else {
              this.setState({comms_error:true,status:'',showSpinner:false,warning:'Technical error encountered - we were unable to confirm the status of your previous application(s). Please refresh this page and try again. If this problem persists, please contact us.'});
          }
        });
    }

    backToPayGate = () => {
        // console.log('Clicked back to paygate...');

        let paygate_url = this.props.paygate_url;

        //populate placeholders in url string...
        paygate_url = paygate_url.replace("[Contact_Email]",this.props.applicant_email);
        paygate_url = paygate_url.replace("[AppMQ_ID]",this.state.openAppId);
        paygate_url = paygate_url.replace("[Item]",this.props.paygate_item);
        paygate_url = paygate_url.replace("[Amount]",this.props.paygate_amount);
        paygate_url = paygate_url.replace("[Return_Url]","https://prime-entry.web.app?op=S" + this.state.openAppId + "~" + this.props.form_token); 
        paygate_url = paygate_url.replace("[Cancel_Url]","https://prime-entry.web.app?op=F" + this.state.openAppId + "~" + this.props.form_token);

        // console.log('paygate_url :>> ', paygate_url);
        
        // this.props.setParentState({showCheckAppStatus:false,paygate_url_exe: encodeURI(paygate_url),showPayGateFrame: true});    
        window.parent.location.href = encodeURI(paygate_url); 

    }

}

